import type {AuthorizeState, AuthorizeStateAction} from '~/types/authorize';

export const initialAuthorizeState: AuthorizeState = {
  devMode: false,
  flow: 'phoneAuth',
  sessionDetected: false,
};

export function authorizeReducer(
  state: AuthorizeState,
  action: AuthorizeStateAction,
) {
  switch (action.type) {
    case 'initialize': {
      const {personalizeConsentChallenge, userFound} = action.payload;

      if (personalizeConsentChallenge) {
        return {
          ...state,
          sessionDetected: userFound,
          step: 'personalizeConsent',
        };
      } else {
        return {
          ...state,
          sessionDetected: userFound,
          step: userFound ? 'oneClick' : 'start',
        };
      }
    }

    case 'popup':
      return {
        ...state,
        step: 'popUpOpened',
      };

    case 'restart':
      return {
        ...state,
        sessionDetected: false,
        step: 'start',
      };

    case 'setFlow':
      return {
        ...state,
        flow: action.payload,
      };

    case 'setUserMatched': {
      const {matched, personalizeConsentChallenge, userCookieExists} =
        action.payload;

      if (matched !== undefined && matched === false) {
        return {
          ...state,
          step: 'signup',
        };
      }

      if (personalizeConsentChallenge) {
        return {
          ...state,
          sessionDetected: Boolean(userCookieExists),
          step: 'personalizeConsent',
        };
      }

      if (userCookieExists) {
        return {
          ...state,
          step: 'oneClick',
          sessionDetected: true,
        };
      }

      return {
        ...state,
        sessionDetected: false,
      };
    }

    default:
      return state;
  }
}
